import { useEffect, useState } from 'react'
import type { PhaseInfo, WorkflowStage } from '../../types/workflow'
import { getArrayVariable } from './template-variable-utils'

interface CheckboxListOption {
  id: string
  label: string
}

interface CheckboxListTemplateProps {
  stage: WorkflowStage
  initialValue?: string[]
  onSelect: (value: string[]) => void
  currentPhase?: PhaseInfo | null
}

function choiceBtn(active: boolean) {
  return `flex items-center gap-3.5 w-full py-4 px-[18px] text-[15px] font-medium text-[var(--ww-text)] text-left rounded-2xl cursor-pointer transition-all duration-300 border glass hover:border-[var(--ww-border-hover)] hover:bg-[var(--ww-surface-2)] hover:-translate-y-px ${
    active
      ? 'border-[var(--ww-accent)] choice-selected shadow-[0_0_16px_rgba(74,138,154,0.12),inset_0_1px_0_rgba(74,138,154,0.15)] selected-glow'
      : 'border-[var(--ww-glass-border)] bg-[var(--ww-surface)]'
  }`
}

export default function CheckboxListTemplate({
  stage,
  initialValue,
  onSelect,
}: CheckboxListTemplateProps) {
  const [selected, setSelected] = useState<string[]>(initialValue || [])
  const options = getArrayVariable<CheckboxListOption>(stage.templateVariables, 'options', [])

  useEffect(() => {
    if (initialValue !== undefined) setSelected(Array.isArray(initialValue) ? initialValue : [])
  }, [initialValue])

  const handleCheckboxChange = (optionId: string) => {
    let newSelected: string[]
    if (optionId === 'none') {
      newSelected = selected.includes('none') ? [] : ['none']
    } else if (selected.includes(optionId)) {
      newSelected = selected.filter((id) => id !== optionId)
    } else {
      newSelected = [...selected.filter((id) => id !== 'none'), optionId]
    }
    setSelected(newSelected)
    onSelect(newSelected)
  }

  return (
    <div className="flex-1 flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        {options.map((option) => {
          const isSelected = selected.includes(option.id)
          return (
            <button
              key={option.id}
              className={choiceBtn(isSelected)}
              onClick={() => handleCheckboxChange(option.id)}
              type="button"
            >
              <span
                className={`flex items-center justify-center w-5 h-5 rounded-[5px] border-[1.5px] shrink-0 transition-all duration-200 ${
                  isSelected ? 'bg-[var(--ww-accent)] border-[var(--ww-accent)] text-white' : 'border-[var(--ww-text-3)]'
                }`}
              >
                {isSelected && (
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </span>
              {option.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
